import { pushDataLayer } from "utils/googletagmanager"
import {
  GTM_SURVEY_NEW_SESSION,
  GTM_SURVEY_NAVIGATION_EXPERIENCE,
  GTM_SURVEY_NAVIGATION_EXPERIENCE_INCOMPLETE,
} from "constant"

// Trigger to create a new survey session and display it as if for a new user.
export const gtmPushSurveyNewSession = () => {
  pushDataLayer({
    event: GTM_SURVEY_NEW_SESSION,
  })
}

// Trigger to show the navigation experience survey.
export const gtmPushSurveyNavigationEXP = () => {
  pushDataLayer({
    event: GTM_SURVEY_NAVIGATION_EXPERIENCE,
  })
}

// Trigger navigation experience survey if navigation is incomplete.
export const gtmPushSurveyNavigationEXPIncomplete = () => {
  pushDataLayer({
    event: GTM_SURVEY_NAVIGATION_EXPERIENCE_INCOMPLETE,
  })
}
